// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'
import AppController from './app_controller'
import { FormActionsController } from './form-actions-controller'
import ChartController from './chart_controller'
import CheckboxSelectAll from '@stimulus-components/checkbox-select-all'
import Flatpickr from 'stimulus-flatpickr'
import CommandPaletteController from './command_palette_controller'
import CustomFieldController from './custom_field_form'
import DashboardController from './dashboard_controller'
import DateFilterController from './date_filter_controller'
import FiltersController from './filters_controller'
import FireworksController from './fireworks_controller'
import { GroupedSelectController } from './grouped_select_controller'
// import Hovercard from './hovercard_controller'
import { NestedFormController } from './nested_form_controller'
import MessageComposerController from './message_composer_controller'
import MessagesListController from './messages_list_controller'
import NoteComposerController from './note_composer_controller'
import Notification from '@stimulus-components/notification'
import PermissionsController from './permissions_controller'
import SearchFormController from './search_form_controller'
import SortableController from './sortable_controller'
import TransitionController from './transition_controller'
import TurboController from './turbo_controller'
import TurboModalController from './turbo_modal_controller'
import { CancellationFormController } from './cancellation_form_controller'
import { CurrentConversationController } from './current_conversation_controller'
import { DropdownController } from './dropdown_controller'
import { AutosizeController, TimeDistanceController } from 'stimulus-library'
import { HotkeysController } from './hotkeys-controller'
import { TooltipController } from './tooltip_controller'
import { ModalController } from './modal_controller'
import { AvatarPickerController } from './avatar_picker_controller'
import { WeekFilterController } from './week_filter_controller'
import { ScrollToBottomController } from './scroll_to_bottom_controller'
import { EditorController } from './editor_controller'
import { ArticleFormController } from './article_form_controller'
import { TagsController } from './tags_controller'
import { ToggleContentController } from '././toggle-content-controller'
import { CheckboxButtonController } from './checkbox_button_controller'
import { DateTimePickerController } from './date_time_picker_controller'
// import { ConversationsController } from './conversations_controller'
import { AutoSubmitController } from './consultant-portal/auto-submit-controller'
import { LinkController } from './link-controller'
import { ComboboxController } from './consultant-portal/combobox-controller'
application.register('combobox', ComboboxController)

import { TaskMemberDropdownController } from './consultant-portal/tasks/member-dropdown-controller'
application.register('task-member-dropdown', TaskMemberDropdownController)

import Clipboard from '@stimulus-components/clipboard'
application.register('clipboard', Clipboard)

application.register('dashboard', DashboardController)
application.register('date-filter', DateFilterController)
application.register('nested-form', NestedFormController)
application.register('form-actions', FormActionsController)
application.register('search-form', SearchFormController)
application.register('dropdown', DropdownController)
application.register('notification', Notification)
application.register('turbo-modal', TurboModalController)
application.register('transition', TransitionController)
application.register('grouped-select', GroupedSelectController)
application.register('chart', ChartController)
application.register('app', AppController)
application.register('filters', FiltersController)
application.register('fireworks', FireworksController)
application.register('sortable', SortableController)
application.register('checkbox-select-all', CheckboxSelectAll)
application.register('permissions', PermissionsController)
application.register('turbo', TurboController)
application.register('custom-field-form', CustomFieldController)
application.register('command-palette', CommandPaletteController)
application.register('time-distance', TimeDistanceController)
application.register('message-composer', MessageComposerController)
application.register('messages-list', MessagesListController)
application.register('note-composer', NoteComposerController)
application.register('cancellation-form', CancellationFormController)
application.register('hotkeys', HotkeysController)
application.register('current-conversation', CurrentConversationController)
application.register('tooltip', TooltipController)
application.register('modal', ModalController)
application.register('avatar-picker', AvatarPickerController)
application.register('week-filter', WeekFilterController)
application.register('scroll-to-bottom', ScrollToBottomController)
application.register('editor', EditorController)
application.register('article-form', ArticleFormController)
application.register('tags', TagsController)
application.register('flatpickr', Flatpickr)
application.register('toggle-content', ToggleContentController)
application.register('autosize', AutosizeController)
application.register('checkbox-button', CheckboxButtonController)
application.register('date-time-picker', DateTimePickerController)
application.register('auto-submit', AutoSubmitController)
application.register('link', LinkController)
// application.register('conversations', ConversationsController)
// application.register('hovercard', Hovercard)

export { application }
